import React, { useState } from "react";
import Img from "gatsby-image";
import css from "./loginForm.modules.scss";
import Button from "@/components/ui-kit/button";
import { useStaticQuery, graphql } from "gatsby";
import { useDispatch } from "react-redux";
import { login } from "@/actions/account.actions";

const LoginForm = () => {
  const { logoImg } = useStaticQuery(graphql`
    query {
      logoImg: file(relativePath: { eq: "logo@2x.png" }) {
        childImageSharp {
          fluid(maxWidth: 316, maxHeight: 74) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = (e: React.SyntheticEvent): void => {
    e.preventDefault();
    dispatch(login({ username, password }));
  };

  return (
    <form className={`flex flex-col ${css.container}`} onSubmit={handleSubmit}>
      <Img className={css.logo} {...logoImg.childImageSharp} />
      <input
        className={`mb-4 border ${css.input}`}
        type="text"
        placeholder="Введите имя пользователя"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        className={`mb-4 border ${css.input}`}
        type="password"
        placeholder="Введите пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button type="submit" className={css.button}>
        Войти
      </Button>
    </form>
  );
};

export default LoginForm;